export default __webpack_public_path__ + "static/media/subscriptions-icon.4d4d6fa3.svg";